export default __webpack_public_path__ + "static/media/book.5fe5ab16.svg";